export var NSFarmPlanner;
(function (NSFarmPlanner) {
    var TVariableType;
    (function (TVariableType) {
        TVariableType["OptionInput"] = "option_input";
        TVariableType["NumericInput"] = "numeric_input";
        TVariableType["NumericCalculation"] = "numeric_calculation";
    })(TVariableType = NSFarmPlanner.TVariableType || (NSFarmPlanner.TVariableType = {}));
    var TVariableSetupStatus;
    (function (TVariableSetupStatus) {
        TVariableSetupStatus["Published"] = "published";
        TVariableSetupStatus["Draft"] = "draft";
        TVariableSetupStatus["Past"] = "past";
    })(TVariableSetupStatus = NSFarmPlanner.TVariableSetupStatus || (NSFarmPlanner.TVariableSetupStatus = {}));
    var TQuestionType;
    (function (TQuestionType) {
        TQuestionType["Slider"] = "slider";
        TQuestionType["Radio"] = "radio";
        TQuestionType["Select"] = "select";
        TQuestionType["NumericInput"] = "numeric_input";
        TQuestionType["VariableView"] = "variable_view";
        TQuestionType["SingleSelectButton"] = "single_select_button";
        TQuestionType["DoubleVariableView"] = "double_variable_view";
        TQuestionType["DoubleInput"] = "double_input";
        TQuestionType["Info"] = "info";
    })(TQuestionType = NSFarmPlanner.TQuestionType || (NSFarmPlanner.TQuestionType = {}));
    var TSectionType;
    (function (TSectionType) {
        TSectionType["Subsection"] = "subsection";
        TSectionType["Side"] = "side";
        TSectionType["Independent"] = "independent";
    })(TSectionType = NSFarmPlanner.TSectionType || (NSFarmPlanner.TSectionType = {}));
    var TLegendItemType;
    (function (TLegendItemType) {
        TLegendItemType["NoVarLegendItem"] = "NOVAR_LEGEND_ITEM";
        TLegendItemType["SingleVarLegendItem"] = "SINGLEVAR_LEGEND_ITEM";
        TLegendItemType["DoubleVarLegendItem"] = "DOUBLEVAR_LEGEND_ITEM";
    })(TLegendItemType = NSFarmPlanner.TLegendItemType || (NSFarmPlanner.TLegendItemType = {}));
})(NSFarmPlanner || (NSFarmPlanner = {}));
//# sourceMappingURL=farmPlanner.js.map